import styled from 'styled-components';
import { LoadingSpinner, UseCurrentLocationIcon } from 'svg';
import { breakpoints, colors } from '../../constants';
import { useTranslation } from 'react-i18next';

const Row = styled.div``;

interface IProps {
    className?: string;
    loading: boolean;
    onClick?(): void;
}

const BaseCurrentLocationButton = ({ className, loading, onClick }: IProps) => {
    const { t } = useTranslation();

    return (
        <div className={className} onClick={onClick}>
            {loading ? (
                <LoadingSpinner />
            ) : (
                <Row>
                    <UseCurrentLocationIcon />
                    <span>{t('useCurrentLocation')}</span>
                </Row>
            )}
        </div>
    );
};

export const CurrentLocationButton = styled(BaseCurrentLocationButton)`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: ${colors.white};
    color: ${colors.black};
    font-size: 1rem;
    font-weight: 500;
    border: 2px solid ${colors.black};
    border-radius: 3px;
    transition: all 0.2s ease-in-out;

    &:hover {
        border: 2px solid ${colors.greyDark};
        color: ${colors.greyDark};

        ${UseCurrentLocationIcon} {
            fill: ${colors.greyDark};
        }
    }

    @media (${breakpoints.mediumMin}) {
        max-width: initial;
        width: 100%;
    }

    ${LoadingSpinner} {
        width: 24px;
        height: 24px;
        stroke: ${colors.white};
    }

    ${Row} {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    ${UseCurrentLocationIcon} {
        transition: fill 0.15s linear;
        margin-right: 10px;
        fill: ${colors.offBlack};
    }
`;
